// extracted by mini-css-extract-plugin
export default {"emptyPicIcon":"styles__emptyPicIcon___Zz62Q"};